// Since you can't test this module in development mode,
// this is an example of what you get from success message of payment gateway
//
// {
//  "id": 25142,
//  "dateStamp": "2021-10-20T15:32:53.248",
//  "date": "1400/07/28",
//  "time": "19:02:53",
//  "userSideId": -1,
//  "userSide": "SYSTEM",
//  "walletTypeId": 1,
//  "walletType": "Spot",
//  "sideId": 1,
//  "side": "Deposit",
//  "typeId": 4,
//  "type": "PaymentGateway",
//  "stateId": 12,
//  "state": "SanaCash Confirmed",
//  "coinId": 4,
//  "coinImageUrl": "/images/coin/toman.png",
//  "coinName": "Toman",
//  "amount": 1500,
//  "fee": 250,
//  "proposal": null,
//  "message": null,
//  "networkId": 40,
//  "network": "Toman",
//  "address": null,
//  "tagOrMemo": null
// }

import { useEffect, useState } from "react";

import FailedPayment from "./Components/FailedPayment";
import LoadingPaymentDetails from "./Components/LoadingPaymentDetails";
import SuccessPayment from "./Components/SuccessPayment";
import http from "config/http";
import { useSearchParams } from "react-router-dom";
import { PAYMENT_GATEWAYS } from "./constants";

function PaymentGatewayCallback() {
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(true);

  const [depositVerify, setDepositVerify] = useState(null);
  const [depositPaymentIsSucceeded, setDepositPaymentIsSucceeded] =
    useState(false);

  const depositGatewayVerify = async () => {
    const returnedDataFromPaymentGateway = {};

    searchParams.forEach((val, key) => {
      returnedDataFromPaymentGateway[key] = val;
    });

    const selectedPaymentGateway = Object.keys(PAYMENT_GATEWAYS).find((key) => {
      const keysExist = Object.keys(returnedDataFromPaymentGateway).every(
        (returnKey) => PAYMENT_GATEWAYS[key].keys.includes(returnKey)
      );

      return keysExist;
    });

    if (selectedPaymentGateway) {
      try {
        const { data } = await http.post(
          PAYMENT_GATEWAYS[selectedPaymentGateway].api,
          returnedDataFromPaymentGateway
        );

        setDepositPaymentIsSucceeded(true);

        setDepositVerify(
          data?.data || {
            id: 25142,
            dateStamp: "2021-10-20T15:32:53.248",
            date: "1400/07/28",
            time: "19:02:53",
            userSideId: -1,
            userSide: "SYSTEM TEST DATA ",
            walletTypeId: 1,
            walletType: "Spot",
            sideId: 1,
            side: "Deposit",
            typeId: 4,
            type: "PaymentGateway",
            stateId: 12,
            state: "SanaCash Confirmed",
            coinId: 4,
            coinImageUrl: "/images/coin/toman.png",
            coinName: "Toman",
            amount: 1500,
            fee: 250,
            proposal: null,
            message: null,
            networkId: 40,
            network: "Toman",
            address: null,
            tagOrMemo: null,
          }
        );
      } catch (e) {
        setDepositPaymentIsSucceeded(false);

        setDepositVerify(e?.response?.data);
      }
    } else {
      setDepositPaymentIsSucceeded(false);

      setDepositVerify({
        errors: [
          { message: "مشکلی پیش‌ آمده است، لطفا با تیم پشتیبانی تماس بگیرید" },
        ],
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    depositGatewayVerify();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!loading ? (
        <>
          {depositPaymentIsSucceeded ? (
            <SuccessPayment depositVerify={depositVerify} />
          ) : (
            <FailedPayment depositVerify={depositVerify} />
          )}
        </>
      ) : (
        <LoadingPaymentDetails />
      )}
    </>
  );
}

export default PaymentGatewayCallback;
